'use strict';

let desktopNav = function () {

  // After nav target clicked, fade out content, then go to target page
  $('a.site-nav-desktop__nav-menu__item, .site-nav-desktop__logo > a').on('click', function (event) {
    event.preventDefault();
    $('.site-content').removeClass('is-in-view');
    setTimeout(function () {
      let targetHref = $(event.currentTarget).attr('href');
      location.href = targetHref;
    }, 350);
  });

  // header hide/show
  let lastScrollTop = 0, delta = 64;
  let $siteNavDesktopWrapper = $('.site-nav-desktop-wrapper');
  $(window).on('scroll', function () {
    let nowScrollTop = $(this).scrollTop();

    if (nowScrollTop < delta * 2) {
      $siteNavDesktopWrapper.removeClass('is-hidden');
      return;
    }

    if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
      if (nowScrollTop > lastScrollTop) {
        // SCROLLING DOWN
        // console.log('down');
        $siteNavDesktopWrapper.addClass('is-hidden');
      } else {
        // SCROLLING UP
        // console.log('up');
        $siteNavDesktopWrapper.removeClass('is-hidden');
      }

      lastScrollTop = nowScrollTop;
    }

  });

};

export default desktopNav;


// WEBPACK FOOTER //
// ./desktopNav.js